/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Publish_Visibilityupdated1Inputs */

const zh_publish_visibilityupdated1 = /** @type {(inputs: Publish_Visibilityupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可见性已更新`)
};

const en_publish_visibilityupdated1 = /** @type {(inputs: Publish_Visibilityupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visibility updated`)
};

const es_publish_visibilityupdated1 = /** @type {(inputs: Publish_Visibilityupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visibilidad actualizada`)
};

/**
* | output |
* | --- |
* | "Visibility updated" |
*
* @param {Publish_Visibilityupdated1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const publish_visibilityupdated1 = /** @type {((inputs?: Publish_Visibilityupdated1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publish_Visibilityupdated1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_publish_visibilityupdated1(inputs)
	if (locale === "en") return en_publish_visibilityupdated1(inputs)
	return es_publish_visibilityupdated1(inputs)
});
export { publish_visibilityupdated1 as "publish_visibilityUpdated" }